export const PROFILE_RESET_VOLUMETRIC_STATS = 'PROFILE:RESET_VOLUMETRIC_STATS';
export const PROFILE_GET_PTS_PLAYER_RANKING_REQUEST = 'PROFILE:GET_PTS_PLAYER_RANKING';
export const PROFILE_GET_PTS_PLAYER_RANKING_SUCCESS = 'PROFILE:GET_PTS_PLAYER_RANKING_SUCCESS';
export const PROFILE_GET_PTS_PLAYER_RANKING_FAILURE = 'PROFILE:GET_PTS_PLAYER_RANKING_FAILURE';
export const PROFILE_RESET_PERFORMANCE_STATS = 'PROFILE:RESET_PERFORMANCE_STATS';
export const PROFILE_GET_PERFORMANCE_STATS = 'PROFILE:GET_PERFORMANCE_STATS';
export const PROFILE_GET_PERFORMANCE_STATS_SUCCESS = 'PROFILE:GET_PERFORMANCE_STATS_SUCCESS';
export const PROFILE_GET_PERFORMANCE_STATS_FAILURE = 'PROFILE:GET_PERFORMANCE_STATS_FAILURE';
export const PROFILE_GET_PERFORMANCE_STATS_OVERVIEW = 'PROFILE:GET_PERFORMANCE_STATS_OVERVIEW';
export const PROFILE_GET_PERFORMANCE_STATS_OVERVIEW_SUCCESS = 'PROFILE:GET_PERFORMANCE_STATS_OVERVIEW_SUCCESS';
export const PROFILE_GET_PERFORMANCE_STATS_OVERVIEW_FAILURE = 'PROFILE:GET_PERFORMANCE_STATS_OVERVIEW_FAILURE';
